import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

const MobileBlock = ({ children }) => {
  useEffect(() => {
    if (!isMobile) return undefined;

    let viewportMeta = document.querySelector('meta[name="viewport"]');
    const previousViewportContent = viewportMeta?.getAttribute('content');

    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      document.head.appendChild(viewportMeta);
    }

    viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1');

    return () => {
      if (previousViewportContent) {
        viewportMeta.setAttribute('content', previousViewportContent);
      }
    };
  }, []);

  if (isMobile) {
    return (
      <div className='yaavaay-mobile-only-screen'>
        <style>
          {`
            html,
            body,
            #root {
              background: #050505 !important;
              margin: 0 !important;
              padding: 0 !important;
              overflow: hidden !important;
            }

            .yaavaay-mobile-only-screen {
              box-sizing: border-box;
              position: fixed;
              inset: 0;
              z-index: 99999;
              width: 100vw;
              height: 100vh;
              height: 100dvh;
              overflow: hidden;
              background: rgba(0, 0, 0, 0.44);
              -webkit-backdrop-filter: blur(3px) brightness(0.58);
              backdrop-filter: blur(3px) brightness(0.58);
              color: #fff;
              font-family: "DIN Condensed", sans-serif;
              font-weight: 700;
              letter-spacing: 0;
              border-left: 5px solid #002bff;
              border-right: 5px solid #002bff;
            }

            .yaavaay-mobile-background {
              box-sizing: border-box;
              position: absolute;
              inset: 0;
              overflow: visible;
              filter: blur(3px) brightness(0.36);
              transform: scale(1.03);
              transform-origin: center;
              pointer-events: none;
              opacity: 0.55;
            }

            .yaavaay-mobile-background * {
              pointer-events: none !important;
            }

            .yaavaay-mobile-message {
              box-sizing: border-box;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 327px;
              max-width: 326px;
              height: 184px;
              max-height: 184px;
              padding: 22px 30px;
              border-radius: 7px;
              background: #002bff;
              color: #fff;
              font-size: 16px;
              line-height: 1.22;
              letter-spacing: 0.25px;
              word-spacing: 1px;
              text-align: center;
              overflow: hidden;
              box-shadow: none;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }

            .yaavaay-mobile-message p {
              display: flex !important;
              justify-content: center !important;
              position: static !important;
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 auto !important;
              padding: 0 !important;
              color: #fff !important;
              background: transparent !important;
              font-family: "DIN Condensed", sans-serif !important;
              font-size: inherit !important;
              font-weight: 700 !important;
              line-height: inherit !important;
              letter-spacing: inherit !important;
              word-spacing: inherit !important;
              text-align: center !important;
              text-decoration: none !important;
              white-space: nowrap !important;
              overflow-wrap: normal !important;
              opacity: 1 !important;
              visibility: visible !important;
            }

            .yaavaay-mobile-intro {
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }

            .yaavaay-mobile-intro p {
              align-self: center !important;
              transform: none !important;
            }

            .yaavaay-mobile-details {
              width: 100%;
              margin-top: 10.32px;
              margin-left: 0;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
            }

            .yaavaay-mobile-final-notice {
              display: flex;
              justify-content: center;
              width: 100%;
              max-width: 100%;
              margin: 0 auto;
              color: #fff;
              font-weight: 700;
              text-align: center;
              text-decoration: none;
              white-space: nowrap;
            }

            @media (max-width: 350px) {
              .yaavaay-mobile-message {
                max-width: calc(100vw - 24px);
              }
            }
          `} 
        </style>
        <div className='yaavaay-mobile-background' aria-hidden='true'>
          {children}
        </div>
        <div className='yaavaay-mobile-message'>
          <div className='yaavaay-mobile-intro'>
            <p>If you allow your governments unto alien disclosure.</p>
            <p>Humanity will drown in never ending lies and delays.</p>
            <p>True disclosure must come from freewill of humanity.</p>
          </div>
          <div className='yaavaay-mobile-details'>
            <p>Designed for desktop optimization</p>
            <p>Limiting chances of malware and</p>
            <p>government censorships with spy</p>
            <p>monitoring user personal details.</p>
            <span className='yaavaay-mobile-final-notice'>(PLEASE NAVIGATE DESKTOP ONLY)</span>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default MobileBlock;
